import React from "react";
import { GaugeIcon, TimerIcon, HelpCircleIcon, FlameIcon, BrainIcon, ShuffleIcon, BoxIcon } from "lucide-react";
import { painPoints } from "../data/content";
import { CtaButton } from "./CtaButton";
const iconMap: Record<(typeof painPoints)[number]["icon"], BoxIcon> = {
  gauge: GaugeIcon,
  timer: TimerIcon,
  help: HelpCircleIcon,
  flame: FlameIcon,
  brain: BrainIcon,
  shuffle: ShuffleIcon
};
export function PainSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-214" data-mp="2l71944mzhl5t">
      <div className="mx-auto max-w-4xl" data-id="element-215" data-mp="2pzc731y5ywvq">
        <div className="text-center" data-id="element-216" data-mp="2q0dnllxy8bku">
          <h2 className="font-serif text-[30px] font-black leading-tight text-ink sm:text-5xl" data-id="element-217" data-mp="2bag0787ufpwp">Do any of these sound familiar?</h2>
          <p className="mt-4 text-lg text-ink/70" data-id="element-218" data-mp="2ga12nsm82ge6">
            If you answer <strong className="text-ink" data-id="element-219" data-mp="229qckrsql5u2">YES</strong> to even one of these, I created this system for you.
          </p>
        </div>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-220" data-mp="2779o3jy1v4ib">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.text} className="flex gap-4 rounded-2xl bg-cream p-5" data-id="element-221" data-mp="3rovg52j28scu">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-ink text-gold" data-id="element-222" data-mp="3nl5uolxomqw1">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-223" data-mp="5dq268j6vcb6" />
                </span>
                <p className="text-[16px] leading-snug text-ink/85" data-id="element-224" data-mp="hiuobb59sr4">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-14 max-w-2xl rounded-3xl bg-ink p-7 text-center text-white sm:p-10" data-id="element-225" data-mp="38u6rjqfm8uju">
          <h3 className="font-serif text-2xl font-black leading-tight sm:text-3xl" data-id="element-226" data-mp="3imcgerakmvut">And it shouldn’t have to be this complicated.</h3>
          <div className="mt-5 space-y-3 text-[17px] leading-relaxed text-white/80" data-id="element-227" data-mp="3dvcltsoxcpvh">
            <p data-id="element-228" data-mp="2q5i5301hih5y">Because the problem isn’t necessarily that you lack discipline.</p>
            <p data-id="element-229" data-mp="2l6ymn9m3nnic">And it isn’t necessarily that you need more information.</p>
            <p className="text-white" data-id="element-230" data-mp="2l4ugel0qacew">
              The problem is that most men were never given a <strong className="text-gold" data-id="element-231" data-mp="p3k23xinejye">structured system</strong> for learning to recognize, regulate, and practice control.
            </p>
            <p data-id="element-232" data-mp="ytvf09kb83hf">That’s exactly why I created The Sexual Control Protocol™.</p>
          </div>
        </div>

        <div className="mt-12" data-id="element-233" data-mp="12vqfxcybweuo">
          <CtaButton label="I want a structured system" data-id="element-234" data-mp="12txcs7mxccrf" />
        </div>
      </div>
    </section>;
}